/* eslint-disable camelcase */
import { BasePlugin, BasePluginData } from '@/models/plugin/basePlugin';

export interface FacebookShortToken {
  access_token: string;
  token_type?: string;
  expires_in?: number;
}

export interface FacebookLongToken {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export interface FacebookUserProfile {
  id: string;
  name: string;
  email?: string;
  picture?: {
    data?: {
      url?: string;
    };
  };
}

export interface FacebookPageProfile {
  id: string;
  name: string;
  access_token?: string;
  category?: string;
  tasks?: string[];
}

export interface WebhookSignupSuccess {
  success: boolean;
}

export interface FacebookPluginData extends BasePluginData {
  page_id: string;
  short_token: FacebookShortToken | null;
  long_token: FacebookLongToken | null;
  page_access_token: string;
  user_profile: FacebookUserProfile | null;
  page_profile: FacebookPageProfile | null;
  webhook_signup_success: WebhookSignupSuccess | null;
}

class FacebookPlugin extends BasePlugin {
  pageId: string;

  shortToken: FacebookShortToken | null;

  longToken: FacebookLongToken | null;

  pageAccessToken: string;

  userProfile: FacebookUserProfile | null;

  pageProfile: FacebookPageProfile | null;

  webhookSignupSuccess: WebhookSignupSuccess | null;

  constructor(data: FacebookPluginData) {
    super(data);
    this.pageId = data.page_id || '';
    this.shortToken = data.short_token || null;
    this.longToken = data.long_token || null;
    this.pageAccessToken = data.page_access_token || '';
    this.userProfile = data.user_profile || null;
    this.pageProfile = data.page_profile || null;
    this.webhookSignupSuccess = data.webhook_signup_success || null;
  }

  getPageName(): string {
    return this.pageProfile?.name || this.name;
  }

  getPageId(): string {
    return this.pageId || this.pageProfile?.id || '';
  }

  hasValidToken(): boolean {
    return !!(this.pageAccessToken || this.longToken?.access_token);
  }

  static fromRow(columns: string[], row: any[]): FacebookPlugin {
    const data: any = {};
    columns.forEach((column, index) => {
      data[column] = row[index];
    });
    return new FacebookPlugin(data as FacebookPluginData);
  }

  static fromApiResponse(columns: string[], rows: any[][]): FacebookPlugin[] {
    if (!rows || rows.length === 0) {
      return [];
    }
    return rows.map((row) => FacebookPlugin.fromRow(columns, row));
  }
}

export default FacebookPlugin;
